var _path, _rect, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMacbook(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 63,
    viewBox: "0 0 99 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.1914 54.5769V4.57692C89.1914 2.88462 87.8068 1.5 86.1145 1.5H12.2683C10.576 1.5 9.19141 2.88462 9.19141 4.57692V54.5769",
    stroke: "#1D1616",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.6992,
    y: 4.5,
    width: 73,
    height: 46,
    rx: 2,
    fill: "#047DED",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1157 54.5762V56.1146H42.2695V54.5762",
    stroke: "#047DED",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1928 9.19216C50.0424 9.19216 50.7312 8.50336 50.7312 7.6537C50.7312 6.80403 50.0424 6.11523 49.1928 6.11523C48.3431 6.11523 47.6543 6.80403 47.6543 7.6537C47.6543 8.50336 48.3431 9.19216 49.1928 9.19216Z",
    fill: "#047DED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.65385 61.4992C3.80769 61.4992 1.5 59.9608 1.5 59.9608V54.5762H96.8846V59.9608C96.8846 59.9608 94.5769 61.4992 90.7308 61.4992C86.8846 61.4992 7.65385 61.4992 7.65385 61.4992Z",
    stroke: "#1D1616",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMacbook);
export default __webpack_public_path__ + "static/media/macbook.160f3b52d5f7cc088d16900e60aba0ef.svg";
export { ForwardRef as ReactComponent };